import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { stylesQueryOptions } from '../../../../-hooks/useStylesQuery';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(list)/styles/archived/',
)({
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      stylesQueryOptions({ ...deps, isArchived: true }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/StylesArchiveTab'),
    'StylesArchiveTab',
  ),
});
